<script>
    export let id;
</script>
<section id="{id}">
    <div class="container mx-auto px-6 py-12 lg:py-36">
        <slot>
            <div
                class="border-4 border-dashed border-gray-200 rounded-lg h-96"
            ></div>
        </slot>
    </div>
</section>